<template>
  <div>
    <h2>CAREGIVER</h2>
    <template v-if="settings_cardTheme != null">
      <div class="row">
        <div
          v-for="aCard in memoryCards"
          class="col-auto mb-3 flip-container"
          :class="{ flipped: aCard.isFlipped, matched: aCard.isMatched }"
          @click="flipCard(aCard)"
        >
          <memory-card
            :assets-url-home="assetsURLHome"
            :card="aCard"
            :cover-img-path="cardsThemeCoverImgPath"
          />
        </div>
      </div>
      <div class="d-flex flex-row justify-content-center py-3">
        <template v-if="settings_showProgressStats">
          <div class="turns p-3">
            <span class="btn btn-info"
              >Turns :
              <span
                class="badge"
                :class="finish ? 'badge-success' : 'badge-light'"
                >{{ turns }}</span
              >
            </span>
          </div>
          <div class="totalTime p-3">
            <span class="btn btn-info"
              >Total Time :
              <span
                class="badge"
                :class="finish ? 'badge-success' : 'badge-light'"
                >{{ min }} : {{ sec }}</span
              ></span
            >
          </div>
        </template>
        <div class="turns p-3" @click="reset(true)">
          <span class="btn btn-info">
            Restart
          </span>
        </div>
        <div class="turns p-3" @click="peekFlip">
          <span class="btn btn-info">
            Peek
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import MemoryCard from "./card";
import themesJSON from "../../assets/json/themes.json";
export default {
  name: "Display_MatchGame",
  mixins: [ResourceBlockDisplay],
  components: {
    MemoryCard
  },
  mounted() {
    this.reset(true);

    //THIS APPS SOUND EFFECTS -- onlyset up once
    if (this.settings_isSoundOn) {
      //switch it to hasSoundEffects or playSoundEffects
      this.setUpSoundEffects();
    }
  },
  computed: {
    settings_showProgressStats() {
      const _default = true;
      return this.settings && this.settings.user
        ? this.settings.user.isDisplayStats
        : _default;
    },
    settings_cardTheme() {
      return this.settings && this.settings.user
        ? this.settings.user.matchGroup
        : null;
    },
    settings_hasBgMusic() {
      return this.settings && this.settings.user
        ? this.settings.user.hasBGMusic
        : true;
    },
    settings_isSoundOn() {
      return this.settings && this.settings.user
        ? this.settings.user.isSoundOn
        : true;
    },
    cardTheme() {
      //has cards and other values
      if (Array.isArray(themesJSON) && this.settings_cardTheme) {
        console.log("In CardTheme");

        let theThemeData = themesJSON.filter(aTheme => {
          console.log(`Settings card theme is ${this.settings_cardTheme} and
           theme is ${aTheme.name}`);
          return aTheme.name === this.settings_cardTheme;
        });
        return theThemeData[0];
      }
      return {};
    },
    sec() {
      if (this.totalTime.seconds < 10) {
        return "0" + this.totalTime.seconds;
      }
      return this.totalTime.seconds;
    },
    min() {
      if (this.totalTime.minutes < 10) {
        return "0" + this.totalTime.minutes;
      }
      return this.totalTime.minutes;
    }
  },
  methods: {
    setUpTheme() {
      //Set Up Cards
      if (
        this.settings_cardTheme &&
        Array.isArray(this.cardTheme.cards) &&
        this.cardTheme.cards.length > 0
      ) {
        this.cards = this.cardTheme.cards;

        //Set Cover
        this.cardsThemeCoverImgPath =
          this.cardTheme.coverImgPath && this.cardTheme.coverImgPath.length > 0
            ? this.cardTheme.coverImgPath
            : "_covers/pattern1.jpg";

        //Set Up BGMusic -- push to playlist
        if (this.settings_hasBgMusic) {
          this.playList.push(
            `${this.assetsURLHome}${this.cardTheme.bgMusicPath}`
          );
          this.playRepeat();
        }
      }
    },
    setUpSoundEffects() {
      this.soundEffects.flip = new Audio(
        `${this.assetsURLHome}/_audio/effects/cardflip.wav`
      );
      this.soundEffects.successJingle = new Audio(
        `${this.assetsURLHome}/_audio/effects/success-jingle.ogg`
      );
    },
    flipCard(card) {
      if (this.soundEffects.flip) {
        //Prep is mixin to make this simple. Push sound smaybe
        this.soundEffects.flip.play();
      }

      if (card.isMatched || card.isFlipped || this.flippedCards.length === 2)
        return;

      if (!this.start) {
        this._startGame();
      }

      card.isFlipped = true;

      if (this.flippedCards.length < 2) this.flippedCards.push(card);
      if (this.flippedCards.length === 2) this._match(card);

      this.handleAppLog({
        name: "display.flipCard",
        payload: {},
        level: "info"
      });
    },
    _match(card) {
      this.turns++;
      if (
        this.flippedCards[0].name === this.flippedCards[1].name &&
        this.flippedCards[0].id !== this.flippedCards[1].id
      ) {
        //Fix issue with card matching with itself

        if (this.soundEffects.successJingle) {
          //Prep is mixin to make this simple. Push sound smaybe
          this.soundEffects.successJingle.play();
        }

        setTimeout(() => {
          this.flippedCards.forEach(card => (card.isMatched = true));
          this.flippedCards = [];

          //All cards matched ?
          if (this.memoryCards.every(card => card.isMatched === true)) {
            clearInterval(this.interval);
            this.finish = true;
          }
        }, 400);
      } else {
        setTimeout(() => {
          this.flippedCards.forEach(card => {
            card.isFlipped = false;
          });
          this.flippedCards = [];
        }, 800);
      }

      this.handleAppLog({
        name: "display._match",
        payload: { turns: this.turns, match: true, card: card },
        level: "info"
      });
    },
    _startGame() {
      this._tick();
      this.interval = setInterval(this._tick, 1000);
      this.start = true;

      this.handleAppLog({
        name: "display._startGame",
        payload: { interval: this.interval },
        level: "info"
      });
    },
    _tick() {
      if (this.totalTime.seconds !== 59) {
        this.totalTime.seconds++;
        return;
      }

      this.totalTime.minutes++;
      this.totalTime.seconds = 0;
    },
    reset(shallPeek) {
      this.setUpTheme();
      clearInterval(this.interval);

      //reset the matching of cards and the  flipping
      this.cards.forEach(card => {
        Vue.set(card, "isFlipped", false);
        Vue.set(card, "isMatched", false);
      });

      setTimeout(() => {
        this.memoryCards = [];
        this.memoryCards = _.shuffle(
          this.memoryCards.concat(
            _.cloneDeep(this.cards),
            _.cloneDeep(this.cards)
          )
        );

        //Give each memory card a unique id to fix bug of mathcing with itself
        let i = 0;
        this.memoryCards.forEach(card => {
          Vue.set(card, "id", i++);
        });

        this.totalTime.minutes = 0;
        this.totalTime.seconds = 0;
        this.start = false;
        this.finish = false;
        this.turns = 0;
        this.flippedCards = [];
      }, 600);
      //
      if (shallPeek) this.peekFlip();

      this.handleAppLog({
        name: "display.reset",
        payload: { shallPeek: shallPeek },
        level: "info"
      });
    },
    peekFlip() {
      this.memoryCards.forEach(card => {
        if (!card.isMatched) Vue.set(card, "isFlipped", true);
      });
      setTimeout(() => {
        this.memoryCards.forEach(card => {
          if (!card.isMatched) Vue.set(card, "isFlipped", false);
        });
      }, 2000);

      this.handleAppLog({
        name: "display.peekFlip",
        payload: {},
        level: "info"
      });
    }
  },
  data() {
    return {
      /* Overrides */
      assetsURLHome: "/assets/apps/matchgame/",
      /* App Specific */
      themesJSON,
      cards: [
        {
          name: "1",
          imgPath: "fruits/apple.png",
          isFlipped: false,
          isMatched: false,
          title: "1",
          audioURL: ""
        },
        {
          name: "2",
          imgPath: "fruits/banana.png",
          isFlipped: false,
          isMatched: false,
          title: "2",
          audioURL: ""
        },
        {
          name: "3",
          imgPath: "fruits/blueberries.png",
          isFlipped: false,
          isMatched: false,
          title: "3",
          audioURL: ""
        }
      ],
      cardsThemeCoverImgPath: "",
      memoryCards: [],
      flippedCards: [],
      finish: false,
      start: false,
      turns: 0,
      totalTime: {
        minutes: 0,
        seconds: 0
      },
      soundEffects: {
        flip: null,
        successJingle: null
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
  min-height: 120px;
  cursor: pointer;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.matched {
  opacity: 0.3;
}
</style>
